import React, { useState, useEffect } from "react";
import { useProSidebar } from "react-pro-sidebar";
import AdminSideBar from "./AdminSideBar";
import MenuIcon from "@mui/icons-material/Menu";

const AdminLayout = ({ children }) => {
  const { toggleSidebar, broken } = useProSidebar();

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <AdminSideBar />

      <main style={{ flexGrow: 1, overflowX: "hidden" }}>
        {broken && (
          <header className="p-3 d-flex justify-content-between align-items-center bg-white shadow-sm admin-mobile-header">
            <button
              className="btn btn-light"
              onClick={() => toggleSidebar()}
              aria-label="Toggle sidebar"
              style={{ color: "black", marginLeft: "5px" }}
            >
              Sidebar
            </button>
          </header>
        )}

        <div className="p-3 p-md-4">{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout;
